import { render } from "./SecondSection.vue?vue&type=template&id=6f7cc72e&scoped=true"
import script from "./SecondSection.vue?vue&type=script&lang=js"
export * from "./SecondSection.vue?vue&type=script&lang=js"

import "./SecondSection.vue?vue&type=style&index=0&id=6f7cc72e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7cc72e"]])

export default __exports__